<template>
  <section class="notification-item-parts">
    <notification-item-contents-parts
      v-if="
        notification.type === 'SFGO_NOTIFICATION_FROM_MANAGEMENT' ||
        notification.type === 'SFGO_GRANT_POINT_FROM_MANAGEMENT' ||
        notification.type === 'comment'
      "
      :notification="notification"
      @handlerClickLink="$emit('handlerClickLink', notification)"
    />
    <highlight-notification-item-contents-parts
      v-if="notification.type === 'highlight'"
      :notification="notification"
    />
  </section>
</template>

<script lang="ts">
import { defineComponent, PropType } from '@vue/composition-api'
import { NotificationItemType } from '@/components/NotificationPane/NotificationPane.vue'
import NotificationItemContentsParts from '@/components/NotificationPane/NotificationPane/parts/NotificationItemContentsParts.vue'
import HighlightNotificationItemContentsParts from '@/components/NotificationPane/NotificationPane/parts/HighlightNotificationItemContentsParts.vue'

/**
 * Notification 詳細アイテム
 */
export default defineComponent({
  name: 'NotificationItemParts',
  components: {
    NotificationItemContentsParts,
    HighlightNotificationItemContentsParts,
  },
  props: {
    notification: {
      type: Object as PropType<NotificationItemType>,
      required: true,
    },
  },
})
</script>

<style lang="scss" scoped>
.notification-item-parts {
  padding: 12px 16px;
}
</style>
